import { ContentContext, CountryContext } from 'Components/hooks/context';
import React, { useContext } from 'react';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { getCountryOverallTrend } from 'Utils/calcOverallTrend';

const atlas = new AtlasMetadataClient();

const Status = (props) => {
  const { globalStatistics, activeCountrySlug } = props;
  const content = useContext(ContentContext);
  const peakContent = content.common.peak;

  const countrySlug = useContext(CountryContext);

  const country = atlas.getCountry(activeCountrySlug || countrySlug);
  const trend = getCountryOverallTrend(globalStatistics, country.isoAlpha2);

  const ofPeak = globalStatistics.distributionRanks.cases[country.isoAlpha2];

  if (isNaN(ofPeak)) return null;

  const Percent = () => (
    <span
      className={classnames({
        red: ofPeak >= 0.9,
        orange: ofPeak >= 0.75 && ofPeak < 0.9,
      })}
    >
      {ofPeak >= 0.01 ? `${Math.round(ofPeak * 100)}%` : '<1%'}
    </span>
  );

  const Peak = () => ofPeak === 1.0 ? (
    <span className='red'>
      {peakContent.atPeak}
    </span>
  ) : (
    <>
      <SmartText
        source={peakContent.ofPeak}
        context={{
          percent: <Percent />,
        }}
      />
    </>
  );

  const Trend = () => {
    if (!trend.cases) return (<p><Peak /></p>);
    if (trend.cases.increasing) {
      return (
        <p>
          <SmartText
            source={peakContent.rising}
            context={{
              peak: <Peak />,
            }}
          /> <FontAwesomeIcon icon={faCaretUp} />
        </p>
      );
    }
    if (trend.cases.decreasing) {
      return (
        <p>
          <SmartText
            source={peakContent.falling}
            context={{
              peak: <Peak />,
            }}
          /> <FontAwesomeIcon icon={faCaretDown} />
        </p>
      );
    }
    return (<p><Peak /></p>);
  };

  return (
    <div className={`status-text ${component}`}>
      <Trend />
    </div>
  );
};

export default Status;
